"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorderRadius = void 0;
var getBorderRadius = function (brand) {
    switch (brand) {
        case 'valtra':
            return 200; // half of height, more than half of max height button
        case 'massey':
            return 5;
        case 'fendt':
        case 'agco':
        default:
            return 0;
    }
};
exports.getBorderRadius = getBorderRadius;
